import React, { useContext } from 'react';
import { ButtonContinue } from '../../common/Button/ButtonContinue';
import { ButtonBack } from '../../common/Button/ButtonBack';
import { useLocation, useNavigate } from 'react-router-dom';
import { PageAbsolutePath } from '../../../consts/Common';
import { faChevronLeft } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Links from '../../common/Widgets/Links';
import { SiteContext } from '../../../context/SiteContext';

const EligibilityAncillaryPage = (): JSX.Element => {
  const navigate = useNavigate();
  const location = useLocation();
  const { site } = useContext(SiteContext);

  const { brand } = site;

  const brandPhoneNumber = brand.brandPhoneNumbers.quotesAndRenewalsNumber;

  const chevronLeftComponent = <FontAwesomeIcon icon={faChevronLeft} />;

  const goBack = (): void => {
    navigate(-1);
  };

  return (
    <div>
      <Links
        id='back-link'
        title=''
        items={[{ to: '', text: 'Back', onClick: goBack }]}
        icon={chevronLeftComponent}
      />
      <h2>Eligibility for Insurance Quote</h2>
      <p>Before you buy, please be aware of the following:</p>
      <ul>
        <li>All drivers should be aged 17 to 90 years</li>
        <li>
          All drivers should be permanent UK residents for the last 3 years.If
          less than 3 years, call us for an annual quote.
        </li>
        <li>
          All drivers should have a full UK driving license. If you have an EU
          or provisional driving licence please call {brandPhoneNumber} for a
          quote
        </li>
        <li>
          All drivers should have zero or a maximum of one county court
          judgement (CCJ) in the last 3 years.
        </li>
        <li>
          No drivers should have been disqualified from driving in the last 5
          years.
        </li>
        <li>
          All cover is subject to the terms and conditions of the policy, the
          Policy Document and the Terms of Business, which will be provided with
          your quote.
        </li>
      </ul>
      <div className='flex-row form-nav'>
        <ButtonBack
          name='btnBack'
          text='Back'
          onClick={goBack}
          additionalClassNames='btn-back'
        />
        <ButtonContinue
          name='button-proceed-appliation'
          text='Proceed to application'
          onClick={() =>
            navigate(PageAbsolutePath.Insurance.AboutYou, {
              state: location.state
            })
          }
          additionalClassNames='btn-continue'
        />
      </div>
    </div>
  );
};

export default EligibilityAncillaryPage;
